import * as React from 'react';
import styled from 'styled-components';
import MuiFormControlLabel, {
    FormControlLabelProps as MuiFormControlLabelProps,
} from '@material-ui/core/FormControlLabel';

const StyledFormControlLabel = styled(MuiFormControlLabel)<DSFormControlLabelProps>``;

export type DSFormControlLabelProps = MuiFormControlLabelProps & {
    onChange?: React.ChangeEvent<HTMLInputElement>;
};
export const DSFormControlLabel: React.FC<DSFormControlLabelProps> = StyledFormControlLabel;
DSFormControlLabel.displayName = 'DSFormControlLabel';
